var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkOperation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63247 7.33325L13.2992 11.9999V23.6666H0.46582V7.33325H8.63247ZM7.66532 9.6666H2.79917V21.3333H10.9658V12.9671L7.66532 9.6666ZM12.1325 3.83325L16.7992 8.4999V20.1666L14.4658 20.1665V9.4671L11.1653 6.1666L3.96582 6.16655V3.83325H12.1325ZM15.6325 0.333252L20.2992 4.9999V16.6666L17.9658 16.6665V5.9671L14.6653 2.6666L7.46582 2.66655V0.333252H15.6325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkOperation);
export default __webpack_public_path__ + "static/media/bulk-operation.ea842e5d229115e879dfe0922b2b612f.svg";
export { ForwardRef as ReactComponent };